import { Dimensions } from "react-native";

export const mainScreen = {
  container: {
    flex: 1,
    paddingHorizontal: 10,
  },
  imageContainer: {
    marginLeft: -5,
    width: Dimensions.get("window").width + 20,
    height: Dimensions.get("window").height + 100,
  },
  iconHeaderLeft: {
    paddingLeft: 10,
  },
  textHeader: {
    fontFamily: "Montserrat-Medium",
    color: "#fff",
    fontSize: 20,
    textAlign: "center",
  },
  textHeaderLight: {
    fontFamily: "Montserrat",
    color: "#ccc",
    fontSize: 22,
    marginVertical: 10,
    textAlign: "center",
  },
  body: {
    padding: 20,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 10,
    paddingHorizontal: 5,
    justifyContent: "center",
    backgroundColor: "#AA000000",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    
  },
  personalData: {
    borderRadius: 8,
    backgroundColor: "#000A",
    marginTop: 10,
  },
  dataProperty: {
    fontFamily: "Montserrat-Medium",
    fontSize: 14,
    color: "#F1F1F1",
  },

  dataValue: {
    fontFamily: "Montserrat",
    marginTop: 2,
    fontSize: 15,
    color: "#C1C1C1",
    marginBottom: 16,
  },
  alert: {
    fontFamily: "Montserrat",
    color: "#999",
    textAlign: "center",
  },
  iconToggle: {
    paddingLeft: 10,
  },
  
};
